import { useEffect, useState } from "react";
import { api, ROLE_LABELS, ROLE_COLORS } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { Card } from "@/components/ui/card";
import { Users, FileText, Megaphone, Ticket } from "lucide-react";

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    api.get("/stats").then(r => setStats(r.data)).catch(()=>{});
    api.get("/announcements").then(r => setAnnouncements(r.data.slice(0,3))).catch(()=>{});
  }, []);

  const cards = [
    { label: "TOPLAM ÜYE", value: stats?.total_users ?? "—", icon: Users, color: "text-emerald-400" },
    { label: "AKTİF DAVET", value: stats?.active_invites ?? "—", icon: Ticket, color: "text-rose-400" },
    { label: "BEKLEYEN MAZERET", value: stats?.pending_excuses ?? "—", icon: FileText, color: "text-amber-400" },
    { label: "TOPLAM DUYURU", value: stats?.total_announcements ?? "—", icon: Megaphone, color: "text-sky-400" },
  ];

  return (
    <div className="p-6 md:p-10 space-y-8 max-w-7xl">
      <header className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <div className="text-[11px] font-mono text-rose-500 tracking-widest mb-2">// COMMAND CENTER</div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight">
            Merhaba, {user.display_name || user.discord_username}
          </h1>
          <p className="text-zinc-500 mt-2">Bugün Deulsra için ne var, tek bakışta gör.</p>
        </div>
        <div className={`px-3 py-1.5 border font-mono text-xs ${ROLE_COLORS[user.role]}`} data-testid="user-role-badge">
          {ROLE_LABELS[user.role]}
        </div>
      </header>

      {user.role !== "candidate" && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {cards.map(c => (
            <Card key={c.label} className="bg-zinc-950 border-zinc-900 p-5 hover:border-rose-900/50 transition-colors">
              <div className="flex items-center justify-between mb-3">
                <c.icon className={`w-5 h-5 ${c.color}`} />
                <div className="w-1.5 h-1.5 rounded-full bg-rose-500 pulse-dot" />
              </div>
              <div className="font-heading text-3xl font-bold tracking-tight">{c.value}</div>
              <div className="text-[10px] font-mono text-zinc-500 tracking-widest mt-1">{c.label}</div>
            </Card>
          ))}
        </div>
      )}

      <section>
        <div className="flex items-baseline justify-between mb-4">
          <h2 className="font-heading text-2xl font-bold tracking-tight">Son Duyurular</h2>
          <div className="text-[10px] font-mono text-zinc-500 tracking-widest">// LATEST</div>
        </div>
        <div className="space-y-3">
          {announcements.length === 0 && (
            <Card className="bg-zinc-950 border-zinc-900 p-6 text-sm text-zinc-500">Henüz duyuru yok.</Card>
          )}
          {announcements.map(a => (
            <Card key={a.id} className={`bg-zinc-950 border-zinc-900 p-5 ${a.urgent ? "border-l-4 border-l-rose-500" : ""}`}>
              <div className="flex items-baseline justify-between gap-4 flex-wrap">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    {a.urgent && <span className="text-[10px] font-mono bg-rose-600/20 text-rose-400 px-2 py-0.5 border border-rose-600/40">ACİL</span>}
                    <h3 className="font-heading font-semibold text-lg">{a.title}</h3>
                  </div>
                  <p className="text-sm text-zinc-400 line-clamp-2">{a.content}</p>
                </div>
                <div className="text-[10px] font-mono text-zinc-500 tracking-wider">
                  {new Date(a.created_at).toLocaleDateString("tr-TR")}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
}
